import React, { useEffect } from "react";
import { Button, DatePicker, Form, Input, Radio } from "antd";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import Icons from "components/icons";
import { Localize } from "components/service";
import StaffManagementForms from "../forms";


const { RangePicker } = DatePicker;
const { Search } = Input;

const StaffAttendanceTableFilter = ({
    eventSubcontractors,
    searchText,
    setSearchText,
    period,
    setPeriod,
    subcontractorID,
    setSubcontractorID,
    groupBy,
    setGroupBy,
    resetPage,
}) => {
    const [ form ] = Form.useForm();
    const hasPeriod = !!period?.length;
    const hasSubcontractor = !!subcontractorID;
    const hasFilters = !!(searchText || hasPeriod || hasSubcontractor);

    useEffect(() => {
        form.setFieldsValue({ subcontractor_id: subcontractorID });
    }, [ form, subcontractorID ]);

    const clearFilters = () => {
        setSearchText("");
        setPeriod([]);
        setSubcontractorID(undefined);
        form.resetFields([ "subcontractor_id" ]);
        resetPage();
    };

    return (
        <Form form={ form } component={ false }>
            <div className="d-flex align-items-center table-action-bar form-controls-compact staff-table-filter staff-table-filter--attendance">
                <div className="d-flex align-items-center table-filter-form staff-table-filter__controls staff-attendance-filter__controls">
                    <Search
                        allowClear={ { clearIcon: <CloseOutlined /> } }
                        className="filter-search"
                        prefix={ <SearchOutlined /> }
                        placeholder={ Localize({ children: "STAFF_MANAGEMENT.Filter_SearchWorker" }).props.children }
                        value={ searchText }
                        onChange={ (event) => {
                            setSearchText(event.target.value);
                            resetPage();
                        } } />

                    <RangePicker
                        allowClear
                        clearIcon={ <CloseOutlined /> }
                        className={ `staff-attendance-filter__period${
                            hasPeriod ?
                                " staff-attendance-filter__period--chosen staff-filter-control--selected" :
                                " range-picker-single-placeholder"
                        }` }
                        format="DD.MM.YYYY"
                        separator="—"
                        suffixIcon={ hasPeriod ? null : <Icons.StaffCalendar /> }
                        placeholder={ [
                            Localize({ children: "STAFF_MANAGEMENT.Filter_SelectPeriod" }).props.children,
                            "",
                        ] }
                        value={ hasPeriod ? period : undefined }
                        onChange={ (value) => {
                            setPeriod(value || []);
                            resetPage();
                        } } />

                    <StaffManagementForms.Fields.SubcontractorSelect
                        eventSubcontractors={ eventSubcontractors }
                        form={ form }
                        selected={ hasSubcontractor }
                        onChange={ (value) => {
                            setSubcontractorID(value);
                            resetPage();
                        } } />

                    { hasFilters &&
                        <Button className="btn-text-link" type="link" onClick={ clearFilters }>
                            <Localize>STAFF_MANAGEMENT.Action_ClearAll</Localize>
                        </Button>
                    }
                </div>

                <div className="d-flex align-items-center staff-attendance-filter__group-by">
                    <span><Localize>STAFF_MANAGEMENT.Filter_GroupBy</Localize></span>

                    <Radio.Group
                        buttonStyle="solid"
                        value={ groupBy }
                        onChange={ (event) => {
                            setGroupBy(event.target.value);
                            resetPage();
                        } }>
                        <Radio.Button value="date">
                            <Localize>STAFF_MANAGEMENT.Group_Date</Localize>
                        </Radio.Button>
                        <Radio.Button value="subcontractor">
                            <Localize>STAFF_MANAGEMENT.Group_Subcontractor</Localize>
                        </Radio.Button>
                    </Radio.Group>
                </div>
            </div>
        </Form>
    );
};

export default StaffAttendanceTableFilter;
